export default {
  pageTitle: 'Consult Now',
  heroTitle: 'Contact Us',
  heroSlogan: 'Focused on cross-border services, integrating law, finance and business to escort enterprises going global',
  heroDesc: 'Our professional team provides one-on-one consulting services, customizing offshore solutions for your enterprise',
  formSuccessMessage: 'Thank you for your message! We will contact you soon.',
  companyAddressTitle: 'Company Address',
  companyAddress1: 'No. 611 Zhongshan North Road, Gongshu District, Hangzhou, Zhejiang',
  companyAddress2: 'Room 1101, 11F Metro Business Building',
  contactMethodsTitle: 'Contact Methods',
  phoneLabel: 'Phone',
  businessHoursTitle: 'Business Hours',
  businessHoursDays: 'Monday to Friday',
  businessHoursTime: '9:00 AM to 6:00 PM',
  onlineConsultation: 'Online Consultation',
  onlineMessageTitle: 'Leave a Message',
  onlineMessageDesc: 'After filling out the form, we will call you promptly!',
  nameLabel: 'Name',
  messageLabel: 'Message',
  messagePlaceholder: 'Please enter your message...',
  submitButton: 'Submit',
  method1Title: 'Phone Consultation',
  method1Desc: 'Business hours 9:00-17:30',
  method2Title: 'WeChat Consultation',
  method2Desc: 'Scan QR code to add WeChat',
  method3Title: 'Email Consultation',
  method3Desc: 'Reply within 24 hours',
  method4Title: 'Appointment for Visit',
  method4Content: 'No.611 Zhongshan North Road, Gongshu District, Hangzhou, Zhejiang, China',
  method4Desc: 'Room 1101, Metro Business Building',
  whyChooseTitle: 'Why Choose Us',
  advantage1: '20+ Years of Industry Experience',
  advantage2: 'Professional Team Service',
  advantage3: 'One-Stop Solution',
  advantage4: 'Global Service Network',
  officeHoursTitle: 'Office Hours',
  weekdays: 'Monday to Friday',
  weekdaysTime: '9:00 - 17:30',
  saturday: 'Saturday',
  sunday: 'Sunday',
  closed: 'Closed',
  officeAddressTitle: 'Office Address',
  addressLine1: 'Gongshu District, Hangzhou, Zhejiang, China',
  addressLine2: 'No.611 Zhongshan North Road',
  addressLine3: 'Room 1101, Metro Business Building',
  viewMap: 'View Map',
  quickLinksTitle: 'Quickly Understand Our Services',
  quickLinksDesc: 'Browse our service pages to understand how we can provide professional support for your enterprise',
  businessServicesLink: 'Business Services',
  legalServicesLink: 'Legal Services',
  aboutUsLink: 'About Us',
  ctaTitle: 'Ready to Start Your Cross-Border Business Journey?',
  ctaDesc: 'Our professional team is ready to provide you with one-on-one consulting services',
  globalNetworkTitle: 'Our Global Network',
  globalNetworkDesc: 'Service network covering the Asia-Pacific region, escorting your cross-border business',
}
